const haveOptionInNewABTests = (optionName, options) =>
  options.some(({ name }) => name === optionName);

export default haveOptionInNewABTests;
